<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Edit Profile" pageTitle="Edit Profile" />
            <EditProfile />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import EditProfile from '../EditProfile/EditProfile'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'EditProfilePage',
    components: {
        MainHeader,
        PageTitle,
        EditProfile,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>